export class CutoffBorder {
    canvas;
    cutoffBorder;
    cutoffBorder_listeners;
    cutoffBorder_cutoffSquare;

    constructor(canvas) {
        this.canvas = canvas;
        this.cutoffBorder_attach();
    }

    cutoffBorder_attach() {
        let el = $('<div class="position-absolute border pe-none cutoff-border" style="z-index: 0"></div>');
        $('#canvas-wrapper').append(el);
        this.cutoffBorder = el;

        this.drawCutoffBorder = this.drawCutoffBorder.bind(this);
        this.cutoffBorder_listeners = {
            'canvas:resize': this.clearCutOffBorder,
            'viewport:pan': this.drawCutoffBorder,
            'viewport:zoom': this.drawCutoffBorder,
        }
        this.canvas.on(this.cutoffBorder_listeners);
    }

    cutoffBorder_detach() {
        if (this.cutoffBorder) {
            this.cutoffBorder.remove();
            this.canvas.off(this.cutoffBorder_listeners);
        }
    }

    clearCutOffBorder() {
        $('.cutoff-border').hide();
    }

    drawCutoffBorder({ square = null }) {
        $('.cutoff-border').show();

        if (square) {
            this.cutoffBorder_cutoffSquare = square;
        }
        square = this.cutoffBorder_cutoffSquare;

        if (!square) {
            return;
        }

        let zoom = this.canvas.getZoom();
        let cords = this.canvas.getAbsoluteCoords(square);
        this.cutoffBorder.css({
            'left': `${cords.left + 1}px`,
            'top': `${cords.top + 1}px`,
            'width': `${square.width * square.scaleX * zoom}px`,
            'height': `${square.height * square.scaleY * zoom}px`,
        });
    }
}
